import { Component, Input } from '@angular/core'

@Component({
  selector: 'app-ib-seat-map',
  templateUrl: './ib-seat-map.component.html',
  standalone: false,
})
export class IbSeatMapComponent {
  @Input() src: string | null = null
}
